"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoMakerFrameApi = void 0;
var tslib_1 = require("tslib");
var frame_opener_1 = require("@wix/frame-opener");
var actions_1 = require("./actions");
/**
 * Api for frame to communicate with opener.
 */
var VideoMakerFrameApi = /** @class */ (function (_super) {
    tslib_1.__extends(VideoMakerFrameApi, _super);
    function VideoMakerFrameApi() {
        return _super.call(this, {
            incomingActions: actions_1.childIncomingActions,
            outgoingActions: actions_1.parentIncomingActions,
        }) || this;
    }
    VideoMakerFrameApi.prototype.kill = function () {
        _super.prototype.offAll.call(this);
    };
    return VideoMakerFrameApi;
}(frame_opener_1.FrameApi));
exports.VideoMakerFrameApi = VideoMakerFrameApi;
//# sourceMappingURL=VideoMakerFrameApi.js.map